import { useCallback } from "react";
import { useAppDispatch } from "@redux/hooks";
import {
  initializeContract,
  resetInitializeContract,
} from "@academy-context/write/application/use-cases/external-provider/subcontracting-contract-enable/enable-subcontracting-contract";
import { useApiAction } from "@shared-kernel/primary/shared/api-errors/use-api-action";
import { applyApiFieldErrors } from "@shared-kernel/primary/shared/api-errors/apply-api-field-errors";
import type { ActionForm } from "@shared-kernel/primary/shared/api-errors/action-form";
import { useExternalProviderRepository } from "../context/external-provider-repository.context";
import {
  CONTRACT_SIGNATORY_FIELD_RENAMES,
  formatFormToSignatory,
  type ContractSignatoryFormInputs,
} from "../form-validation/contract-signatory-form.schema";

// Lien de signature gardé après succès (exception au reset automatique) : seul le refus remet l'état à zéro, le portail
// le remet à zéro en quittant l'écran ou en fermant la signature
export const useContractSignatorySubmit = (form: ActionForm<ContractSignatoryFormInputs>, onSuccess: () => void) => {
  const dispatch = useAppDispatch();
  const run = useApiAction();
  const repository = useExternalProviderRepository();

  // L'API dit pourquoi le contrat ne peut pas être généré (demande pas encore approuvée, contrat déjà signé, signataire
  // délégué incomplet, sous le champ désigné)
  const initialize = useCallback(
    async (values: ContractSignatoryFormInputs) => {
      const outcome = await run(
        initializeContract({ externalProviderRepository: repository, body: { signatory: formatFormToSignatory(values) } }),
        { failure: "Erreur lors de l'initialisation du contrat" },
      );
      if (!outcome.ok) {
        dispatch(resetInitializeContract());
        applyApiFieldErrors(form, outcome.error, CONTRACT_SIGNATORY_FIELD_RENAMES);
        return;
      }
      if (outcome.value) onSuccess();
    },
    [run, repository, dispatch, form, onSuccess],
  );

  return { initialize };
};
